import React, { useState, useContext, useEffect } from "react";
import "../../styles/pages/Banners/BannerManager.scss";
import ValueContext from "../../ContextAPi/appContext";
import TemplateForms from "./TemplateForms";
import CreateTemplateModal from "./CreateTemplateModal";
import BannerTempManagerHeader from "../../components/Manager/BannerTempManagerHeader";
import "./TemplateM.scss";
import NewBannerModal from "../../components/BannerManager/NewBannerModal";
import PromomatsPlaceholder from "../../components/BannerManager/PromomatsPlaceholder";

export default function TemplateLandingPage({
  setIsOpen,
  isOpen,
  toggleLandingPage,
  banner,
  activeButton,
  setActiveButton,
  handleChange,
  openModalOnLoad,
  setopenModalOnLoad,
}) {
  const initialFvalues = {
    brand: [], //"",
    campaign: "",
    market: "",
    templateNameInput: "",
    canReset: false,
    templateType: "",
    contentType: [],
  };
  const appData = useContext(ValueContext);
  const [showNewTemplate, setShowNewTemplate] = useState(false);
  const [preDefined, setPredefined] = useState(true);
  const [selectedTab, setSelectedtab] = useState(0);
  const [filtersData, setFiltersData] = useState({ createdByMe: true });
  const [values, setValues] = useState(initialFvalues);
  const [isSearchBarEmpty, setIsSearchBarEmpty] = useState(true);
  const [customTemp, setCustomBannerSize] = React.useState(false);
  const [clickOncrossIcon, setClickOncrossIcon] = useState(true);
  const [bannerDetails, setBannerDetails] = useState({
    assetName: "",
    assetType: "",
    brandName: "",
    bannerLink: "",
    marketName: "",
    width: "",
    height: "",
    campaign: "",
    veevaDocNumber: "",
    reviewStatus: "",
    createdBy: "",
    createdOn: "",
    updatedBy: "",
    updatedDateTime: "",
    isAnimated: false,
    createdByName: "",
    updatedByName: "",
    createdDateTime: "",
    damDocNumber: "",
    sourceTemplateInfo: {
      assetName: "",
      brandName: "",
      campaign: "",
      marketName: "",
      createdBy: "",
      cratedByName: "",
      createdDateTime: "",
      updatedDateTime: "",
    },
    isBannerCreated: false,
    bannerCount: "",
  });
  const handleCreateTempModal = () => {
    setShowNewTemplate(!showNewTemplate);
  };
  const [showNewBanner, setShowNewBanner] = useState(false);

  const openNewBannerModal = (isRedirectFlag = false) => {
    setShowNewBanner(!showNewBanner);
    if (isRedirectFlag === true) {
      appData.setFlagEditBanner(false);
      appData.setBannersEditCardData({
        cards: "",
      });
    }
  };
  const handleFilter = (key, data) => {
    let newBrandData = [];
    let newMarketData = [];

    if (data) {
      data.forEach((item) => {
        if (item.brandName) {
          newBrandData.push(item);
        } else if (item.marketName) {
          newMarketData.push(item);
        }
      });
    }
    if (key === "brand") {
      setValues({ ...values, brand: newBrandData });
    } else if (key === "market") {
      setValues({ ...values, market: newMarketData });
    }
  };

  const deleteFilterOption = (item) => {
    let newFilterData = { ...values };
    if (newFilterData["brand"]?.length > 0) {
      newFilterData["brand"] = newFilterData["brand"].filter(
        (i) => i.id !== item.id
      );
    }
    if (typeof newFilterData["market"] === "string") {
      if (newFilterData["market"] === item.displayName) {
        newFilterData["market"] = "";
      }
    } else if (Array.isArray(newFilterData["market"])) {
      newFilterData["market"] = newFilterData["market"].filter(
        (i) => i.displayName !== item.displayName
      );
    }
    if (newFilterData["templateType"]?.length > 0) {
      newFilterData["templateType"] = newFilterData["templateType"].filter(
        (i) => i.displayName !== item.displayName
      );
    }
    if (newFilterData["contentType"]?.length > 0) {
      newFilterData["contentType"] = newFilterData["contentType"].filter(
        (i) => i.displayName !== item.displayName
      );
    }
    if (newFilterData?.templateNameInput === item.displayName) {
      newFilterData.templateNameInput = "";
    }
    setValues(newFilterData);
    setIsSearchBarEmpty(true);
    setClickOncrossIcon(true);
  };

  const resetAll = () => {
    setFiltersData([]);
  };
  useEffect(() => {
    if (openModalOnLoad) {
      setShowNewBanner(true);
    }
  }, [openModalOnLoad]);

  return (
    <>
      <div className="row align-items-center TemplateMangerHeaderRow ">
        <BannerTempManagerHeader
          selectedTab={selectedTab}
          setSelectedtab={setSelectedtab}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          banner={banner}
          toggleLandingPage={toggleLandingPage}
        />
      </div>

      <div>
        <TemplateForms
          setBannerDetails={setBannerDetails}
          bannerDetails={bannerDetails}
          banner={banner}
          preDefined={preDefined}
          setPredefined={setPredefined}
          customTemp={customTemp}
          setCustomBannerSize={setCustomBannerSize}
          handleFilter={handleFilter}
          handleChange={handleChange}
          filtersData={filtersData}
          setFiltersData={setFiltersData}
          setIsOpen={setIsOpen}
          isOpen={isOpen}
          openNewBannerModal={openNewBannerModal}
          handleCreateTempModal={handleCreateTempModal}
          activeButton={activeButton}
          setActiveButton={setActiveButton}
          initialFvalues={initialFvalues}
          values={values}
          setValues={setValues}
          deleteFilterOption={deleteFilterOption}
          resetAll={resetAll}
          setIsSearchBarEmpty={setIsSearchBarEmpty}
          isSearchBarEmpty={isSearchBarEmpty}
          clickOncrossIcon={clickOncrossIcon}
        />
      </div>
      {showNewTemplate && (
        <CreateTemplateModal
          showNewTemplate={showNewTemplate}
          setShowNewTemplate={setShowNewTemplate}
          assetType={banner}
        />
      )}
      {showNewBanner && openModalOnLoad ? (
        <NewBannerModal
          showNewBanner={showNewBanner}
          setShowNewBanner={setShowNewBanner}
          assetType={banner}
          preDefined={preDefined}
          setPredefined={setPredefined}
          customTemp={customTemp}
          setCustomBannerSize={setCustomBannerSize}
          handleFilter={handleFilter}
          banner={banner}
          selectedFilterData={filtersData["brand"]}
          setopenModalOnLoad={setopenModalOnLoad}
        />
      ) : (
        <PromomatsPlaceholder
          showNewBanner={showNewBanner}
          setShowNewBanner={setShowNewBanner}
        />
      )}
    </>
  );
}
